export interface Configuratore {
  olsFp: {
    lineaProdotto: LineaEnum;
    nucleoFamigliare: boolean;
  };
  frazionamento?: number;
  codiceSconto?: string;
  tokenIntermediario: string;
}

export enum LineaEnum {
  mob = "Mobilita",
  mobViv = "Mobilita+ViverePienamente",
  mobVivLav = "Mobilita+ViverePienamente+LavoroDipendente",
}

export interface PrezzoCalcolato {
  prezzo?: number;
  prezzoAnnuo?: number;
}

export interface CheckoutInitResponse {
  url: string;
  token: string;
}
